module.exports = __webpack_public_path__ + "static/img/e2.ad02049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/e2.png
// module id = XQmF
// module chunks = 1